import React, { useState } from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../../../components';
import { useIntl } from '../../../../util/reactIntl';
import mockupHeroEn from '../../../../assets/images/merchant-hero-dashboard-en.png';
import mockupHeroAr from '../../../../assets/images/merchant-hero-dashboard-ar.png';
import {
  ArrowRightIcon,
  PlayCircleIcon,
  SparklesIcon,
} from '../MerchantIcons';
import WatchDemoModal from '../WatchDemoModal/WatchDemoModal';
import css from './MerchantHero.module.css';

/**
 * Merchant landing hero — visual reference: for-business.tsx hero section.
 */
const MerchantHero = () => {
  const intl = useIntl();
  const [demoOpen, setDemoOpen] = useState(false);
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';

  const headlineLead = intl.formatMessage({ id: 'ForBusiness.heroHeadlineLead' });
  const headlineHighlight = intl.formatMessage({ id: 'ForBusiness.heroHeadlineHighlight' });

  return (
    <>
      <section className={classNames(css.heroSection, arabicLanguage && css.arabicDirection)}>
        <div className={css.heroGrad} aria-hidden="true" />
        <div className={css.heroInner}>
          <div className={css.heroCopy}>
            <div className={css.forBusinessPill}>
              <SparklesIcon className={css.pillIcon} />
              {intl.formatMessage({ id: 'ForBusiness.forBusiness' })}
            </div>
            <h1 className={css.headline}>
              {headlineLead}{' '}
              <span className={css.headlineHighlightWrap}>
                <span className={css.headlineHighlightText}>{headlineHighlight}</span>
                <span className={css.headlineHighlightBar} aria-hidden="true" />
              </span>
            </h1>
            <p className={css.subheading}>
              {intl.formatMessage({ id: 'ForBusiness.heroSubheading' })}
            </p>
            <div className={css.ctaRow}>
              <NamedLink
                className={css.primaryCta}
                name="SignupForUserTypePage"
                params={{ userType: 'provider' }}
              >
                {intl.formatMessage({ id: 'ForBusiness.getStarted' })}
                <ArrowRightIcon className={css.ctaArrow} />
              </NamedLink>
            </div>
          </div>

          <div className={css.mockupWrap}>
            <img
              src={arabicLanguage ? mockupHeroAr : mockupHeroEn}
              alt={intl.formatMessage({ id: 'ForBusiness.mockupAlt' })}
              className={css.mockupImage}
              width={1633}
              height={963}
            />
            <button
              type="button"
              className={css.watchDemoButton}
              onClick={() => setDemoOpen(true)}
            >
              <span className={css.watchDemoIconWrap} aria-hidden="true">
                <PlayCircleIcon className={css.watchDemoIcon} />
              </span>
              <span className={css.watchDemoLabel}>
                {intl.formatMessage({ id: 'ForBusiness.watchDemo' })}
              </span>
            </button>
          </div>
        </div>
      </section>

      <WatchDemoModal isOpen={demoOpen} onClose={() => setDemoOpen(false)} />
    </>
  );
};

export default MerchantHero;
